import './onboarding.css';

import { Button } from '@kerfjs/ui/button';
import { Checkbox } from '@kerfjs/ui/checkbox';
import { ContentItem } from '@kerfjs/ui/content-item';
import { List } from '@kerfjs/ui/list';
import { ListInsetControl } from '@kerfjs/ui/list-inset-control';
import { StateBanner } from '@kerfjs/ui/state-banner';
import { Text } from '@kerfjs/ui/text';
import { TextField } from '@kerfjs/ui/text-field';
import { type SafeHtml } from 'kerfjs';

import { CardHeader } from '../../../components/card-header.js';
import { notice } from '../../../data/state.js';

export function Onboarding(): SafeHtml {
  return (
    <div class="onboarding">
      <ContentItem appearance="surface" frame="framed">
        <CardHeader title="Create Your Organization" size="xlarge" headingLevel={1} id="onboarding-title" />

        <List gap="m">
          <ListInsetControl>
            <Text tone="quiet">Set up your company so Karwan can track demands, quotations, and savings.</Text>
          </ListInsetControl>

          <List gap="m" controlInsets="rl">
            <TextField type="text" name="name" label="Organization Name" placeholder="e.g. Karwan Textiles" autofocus />
            <TextField type="text" name="country" label="Country" value="Pakistan" />
            <TextField type="text" name="baseCurrency" label="Base Currency" value="PKR" />
            <TextField
              type="text"
              name="industryTags"
              label="Industry Tags"
              placeholder="textiles, sugar (comma separated)"
            />
            <TextField type="text" name="siteName" label="First Site Name" value="Main site" />
            <Checkbox name="importCapable" checked label="We can import directly from abroad" />
          </List>

          {notice.value !== '' ? <StateBanner tone="danger" title={notice.value} /> : null}
        </List>

        <ListInsetControl>
          <Button size="default" tone="brand" emphasis="primary" action="create-org">
            Create Organization
          </Button>
        </ListInsetControl>
      </ContentItem>
    </div>
  );
}
